import React, { useEffect, useState } from 'react';
import { Divider, styled } from '@mui/material';
import {
    StyledModalClientSubtitles,
    StyledModalClientTitles,
    StyledColumnBox,
    StyledRowBox
} from '../../theme/StyledElements';
import { useTranslation } from 'react-i18next';
import { PartagePanierViewData } from '../../models/PartagePanierViewData';
import { Commandes } from '../../models/Commandes';
import { ProfilePhoto } from '../ProfilePhoto';
import { getImageKitUrlFrom, getInitials } from '../../utils';
import { useMountedRef } from '../../hooks/useMountedRef';
import { getClientProfilePhoto } from '../../services/storageFunctions';
import { BasketGroupData } from '../../models/BasketGroupData';

export const StyledDivider = styled(Divider)(() => ({
    borderColor: '#134C03',
    borderLeftWidth: 'medium',
    margin: '0px',
    height: '20px',
    marginLeft: '40px',
    borderRightWidth: 'inherit'
}));

interface PrimaryClientCardProps {
    item: BasketGroupData;
    order: Commandes | undefined;
}

export function PrimaryClientCard({ item, order }: PrimaryClientCardProps): React.ReactElement {
    const { t } = useTranslation();
    const mounted = useMountedRef();
    const [photo, setPhoto] = useState<string>('');

    useEffect(() => {
        if (item.idClient?.urlPhoto && mounted.current) {
            getClientProfilePhoto(item.idClient?.urlPhoto).then((data) => {
                if (data && mounted.current) {
                    setPhoto(data);
                }
            });
        }
    }, [item.idClient?.urlPhoto]);

    return (
        <StyledRowBox>
            {item.idClient?.prenom && (
                <ProfilePhoto
                    url={getImageKitUrlFrom(photo)}
                    size="80px"
                    initials={getInitials(item.idClient?.prenom, item.idClient?.nom)}
                />
            )}
            <StyledColumnBox
                sx={{
                    justifyContent: 'center'
                }}>
                <StyledModalClientTitles variant="body2" sx={{ marginBottom: '10px' }}>
                    {t('collectionBy', {
                        firstName: item.idClient?.prenom,
                        lastName: item.idClient?.nom
                    })}
                </StyledModalClientTitles>
                <StyledModalClientTitles variant="body2">
                    {t('recoveryDate&Time')}
                </StyledModalClientTitles>
                <StyledModalClientSubtitles variant="caption">
                    {order && order.pickupDay}
                </StyledModalClientSubtitles>
                <StyledModalClientSubtitles variant="caption">
                    {order &&
                        t('recoveryTime', {
                            from: order.pickupTimeSlot?.substring(0, 5),
                            to: order.pickupTimeSlot?.substring(8, 13)
                        })}
                </StyledModalClientSubtitles>
            </StyledColumnBox>
        </StyledRowBox>
    );
}
